export const hr = {
    idle1: 'Izuzetan lot!',
    idle2: 'Vrijeme je za nadmetanje!',
    idle3: 'Ne propustite!',
    idle4: 'Posljednja prilika za nadmetanje!',
    seconds: '{value} sekundi je preostalo za nadmetanje!',
    fairwarningclose: 'Upozorenje! Nadmetanje za ovaj lot će uskoro završiti!',
    error: 'Došlo je do pogreške. Ispričavamo se na smetnji i molimo Vas da pokušate ponovno.',
    bids: {
        current: 'Trenutna cijena',
        ask: 'Tražena cijena',
        bid: 'Ponudite',
        bid_warn: 'PAŽNJA! Ponudite',
        highest: 'Vi ste najveći ponuditelj s {value} EUR!',
        sent: 'Vaša ponuda od {value} EUR je poslana.',
        wait: 'Pričekajte početak nadmetanja!',
        sold: 'Prodano!',
        congrats: 'Čestitamo!',
        pass: 'Idući lot!',
        received: 'Vaša ponuda od {value} je primljena!',
        confirmation: 'Upravo ćete dati ponudu',
        confirmation_info: 'Jeste li sigurni da želite dati ponudu za lot?',
        hold: 'Nastavite držati gumb da biste se nadmetali...',
        outbid: 'Vaša ponuda je nadmašena!',
        more: 'ili ponudite više',
        is_bidding: 'Šaljemo Vašu ponudu...',
    },
    account: {
        review: 'Pregledajte svoj račun!',
        login: 'Prijavite se za nadmetanje!',
        your_paddle: 'Vaša aukcijska palica je',
        status_asteptare: 'Vaš račun čeka odobrenje',
        aprobat: 'Vaš račun je odobren',
        neaprobat: 'Neodobreni račun',
    },
    lots: {
        prev: 'Prethodno',
        next: 'Sljedeće',
        no_results: 'Nema rezultata za',
        no_more_lots: 'Nema više lotova za pokazati',
        sold: 'Prodano',
        pass: 'Prošlo',
        withdrawn: 'Opozvano',
        sold_post: 'Prodano nakon aukcije',
        open: 'Otvoreno za nadmetanje',
        recalled: 'Ponovno uvedeno',
        support: 'Podrška uživo na',
        search_lots: 'Pretražite lotove'
    },
    lot: {
        recall: 'Ponovno uvedi',
        recalled: 'Zahtjev za ponovnim uvođenjem je poslan',
        absentee: 'Ponuda u odsutnosti',
        absentee_sent: 'Ponuda u odsutnosti je poslana',
        reminder: 'Podsjetnik za ponudu',
        details: 'Detalji',
        next: 'Sljedeće'
    },
    general: {
        lot: 'Lot',
        est: 'Est',
        sp: 'PC', // 'Početna cijena',
        close: 'Zatvori',
        deactivate: 'Deaktiviraj',
        cancel: 'Otkaži',
        loading: 'Loading',
        standby: 'Pripremite se! Aukcija će ubrzo započeti!',
        break: 'Aukcija je pauzirana! Molimo Vas pričekajte!',
        ended: 'Aukcija je završila! Hvala Vam na sudjelovanju!',
        back_to_current: 'Natrag na aukciju\trenutni lot',
        room_view: 'Prebaci na pregled sobe',
        standard_view: 'Prebaci na standardni pregled',
        turn_on_sound: 'Uključi zvuk',
        turn_off_sound: 'Isključi zvuk',
        mute_video: 'Isključi zvuk videa',
        unmute_video: 'Uključi zvuk videa',
        mute_sounds: 'Isključite zvukove',
        unmute_sounds: 'Uključite zvukove',
        redirect_home: 'Za {seconds} sekundi ćete biti preusmjereni na početnu stranicu...',
        redirect_old: 'Za {seconds} sekundi ćete biti preusmjereni na Artmark Live aplikaciju...',
        redirect_now: 'Preusmjeri me sada!',
        reload_all: 'Aplikacija će se ponovno učitati za {seconds} sekundi...',
        reload_now: 'Reload acum!',
        welcome: 'Dobrodošlli u Artmarkovu aukcijsku platformu uživo! Aukcija će uskoro započeti, kao što je vidljivo na timeru. Pozivamo vas da prije sudjelovanja pažljivo proučite <a href="/hr/pravila-aukcije" target="_blank" class="underline">Pravila za licitaciju</a>. Ako imate bilo kakvih pitanja vezanih za pravila aukcije, možete nam se obratiti putem <a href="mailto:office@artmark.hr" class="underline">office@artmark.hr</a>. Ako imate pitanja u vezi aukcijskih lotova, možete nam se obratiti putem <a href="mailto:aukcije@artmark.hr" class="underline">aukcije@artmark.hr</a>. Sretno!',
        ok: 'Ok',
        contact_1: '<a href="mailto:aukcije@artmark.hr" class="underline">aukcije@artmark.hr</a>',
        contact_2: '',
    },
    modals: {
        send_offer: 'Položite ponudu',
        send_offer_details: 'Izaberite najviši iznos koji želite ponuditi. Mi ćemo se nadmetati u Vaše ime do iznosa kojeg ste označili, nećemo ga premašiti',
        send_absentee_bid: 'Pošaljite ponudu u odsutnosti',
        maximum_amount: 'Najviši iznos',
        bid_more: 'Ponudite viši iznos',
        bid_more_details: 'Jeste li sigurni da želite ponuditi ',
        bid_more_confirmation: 'Položite odabrani iznos',
        recall_title: 'Ponovno uvedi',
        recall_details: 'Jeste li sigurni da želite ponovno uvesti lot {lot}, {description}? Mi ćemo automatski postavljati ponude u Vaše ime, za ',
        recall_reserve: 'Rezervna cijena je ',
        recall_starting_prince: 'Početna cijena je ',
        recall_continue: 'Želite li nastaviti?',
    },
    messages: {
        lot_announce: 'Lot {lot}',
        lot_open: 'Licitacija je počela! Sadašnja ponuda je za {ask} EUR!',
        lot_open_winner: 'Trenutačna cijena lota je {curent} EUR koju nudi {paddle}',
        lot_reserve: 'Rezervna cijena od {value} EUR je vaša!',
        lot_sell_congrats: 'Čestitke! Lot je vaš.',
        lot_sell: 'Lot je prodan!',
        lot_pass: 'Idući lot',
        lot_pass_reserve: 'Rezervna cijena nije postignuta. Idući lot',
        lot_reset: 'Lot {lot}',
        bid_win_congrats: 'Pobijedili ste u licitaciji s {value} EUR!',
        bid_win: '{paddle} pobijedio je u licitaciji s {ask} EUR',
        bid_outbid: 'Vaša ponuda je nadmašena!',
        price_changed: 'Trenutačna cijena lota je {price} EUR',
        ask_changed: 'Ponuđena cijena je sada {ask} EUR',
        bid_receive: '{paddle} je ponudio {ask} EUR',
        lot_warn: 'Upozorenje, posljednja šansa...',
        lot_warn_fairwarningclose: 'Upozorenje, posljednja šansa...',
        lot_warn_once: 'Ide prvi put...',
        lot_warn_twice: 'Ide drugi put..',
        lot_warn_seconds: 'Preostalo je još {seconds} sekundi...',
        // lot_recall: 'The recall of lot {lot} has been requested',
        lot_recall: '{paddle} je zatražio vraćanje lota {lot}.'
    },
    timer: {
        days: 'dana',
        hours: 'sati',
        minutes: 'minuta',
        seconds: 'sekundi',
    }
}
